/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gb: NonNullable<unknown> }} Embed_Captions_Confirm_Storage_LabelInputs */

const en_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Storage (${i?.gb} GB):`)
};

const fr_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stockage (${i?.gb} Go) :`)
};

const de_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Speicherplatz (${i?.gb} GB):`)
};

const it_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archiviazione (${i?.gb} GB):`)
};

const ru_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Объем памяти (${i?.gb} ГБ):`)
};

const es_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Almacenamiento (${i?.gb} GB):`)
};

const zh_cn2_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`存储空间（${i?.gb} GB）：`)
};

const ja_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ストレージ (${i?.gb} GB):`)
};

const hi_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`भंडारण (${i?.gb} जीबी):`)
};

const pt_pt2_embed_captions_confirm_storage_label = /** @type {(inputs: Embed_Captions_Confirm_Storage_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Armazenamento (${i?.gb} GB):`)
};

/**
* | output |
* | --- |
* | "Storage ({gb} GB):" |
*
* @param {Embed_Captions_Confirm_Storage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_storage_label = /** @type {((inputs: Embed_Captions_Confirm_Storage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Storage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_storage_label(inputs)
	if (locale === "de") return de_embed_captions_confirm_storage_label(inputs)
	if (locale === "it") return it_embed_captions_confirm_storage_label(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_storage_label(inputs)
	if (locale === "es") return es_embed_captions_confirm_storage_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_storage_label(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_storage_label(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_storage_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_storage_label(inputs)
	return en_embed_captions_confirm_storage_label(inputs)
});